import axios, { AxiosError } from 'axios'
import { Result, ResultAsync, err } from 'neverthrow'

export const getFileBlobsFromUrls = async (
  fileUrls: string[],
): Promise<Record<string, Result<Blob, unknown>>> => {
  return Object.fromEntries(
    await Promise.all(
      fileUrls.map(async it => [it, await getFileBlobFromUrl(it)]),
    ),
  )
}

const getFileBlobFromUrl = (url: string): ResultAsync<Blob, Error> => {
  return urlValidator.test(url)
    ? getBlobFromHttp(url)
    : getBlobFromVideoManager(url)
}

const getBlobFromHttp = (url: string): ResultAsync<Blob, AxiosError> => {
  const promise = axios.get<Blob>(url, {
    responseType: 'blob',
  })

  return ResultAsync.fromPromise(promise, error => error as AxiosError).map(
    it => it.data,
  )
}

const getBlobFromVideoManager = (
  vmEndpoint: string,
): ResultAsync<Blob, Error> => {
  const url = `${window._env_.API_URL}/videomanager/api${vmEndpoint}`

  return toResult(fetch(url)).andThen(res => {
    if (!res.ok) return err(new Error(`Status ${res.status}.`))
    return toResult(res.blob())
  })
}

const urlValidator = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$',
  'i',
)

function toResult<T>(promise: Promise<T>): ResultAsync<T, Error> {
  return ResultAsync.fromPromise(promise, error => error as Error)
}
